import { Box, Typography } from '@mui/material';
import { getDroppedOrSelectedFiles } from 'html5-file-selector';
import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import { appUrls } from 'src/utils/ajax';

/*
https://www.positronx.io/react-image-upload-with-preview-percentage-progress-bar-tutorial/
*/
interface ImageUploadComponentProps {
    onUploadStatusChange: (id?: number) => void
    initialFileUrl: string
}

const ImageUploadComponent: React.FC<ImageUploadComponentProps> = ({ initialFileUrl, onUploadStatusChange }) => {
	const [initPreviewUrl, setInitPreviewUrl] = useState(initialFileUrl)

	useEffect(() => {
		setInitPreviewUrl(initialFileUrl)
	}, [initialFileUrl])
	const fileParams = ({ meta, file }) => {
		const body = new FormData()
		body.append('fileContent', file)
		return { url: `${appUrls.azure_api}/images/${meta.name}`, body }
	}
	const onFileChange = (fileMeta, status) => {
        switch (status) {
            case 'done': {
                let response = JSON.parse(fileMeta.xhr?.response)
                onUploadStatusChange(response.data.id)
				setInitPreviewUrl(null)
                break;
            }

            case 'removed': {
                onUploadStatusChange()
                break;
            }
        
            default:
                break
        }
	}

	const getFilesFromEvent = (e) => {
		return new Promise<any>((resolve) => {
			getDroppedOrSelectedFiles(e).then((chosenFiles) => {
				resolve(chosenFiles.map((f) => f.fileObject))
			})
		})
	}

	// const selectFileInput = ({ accept, onFiles, getFilesFromEvent }) => {
	// 	return (
	// 		<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
	// 			<Box marginRight={2}>{initPreviewUrl && <img style={{ height: 100 }} src={`${initPreviewUrl}`}></img>}</Box>
	// 			<Box>
	// 				Select Files
	// 				<input
	// 					type="file"
	// 					accept={accept}
	// 					onChange={(e) => {
	// 						getFilesFromEvent(e).then((chosenFiles) => {
	// 							onFiles(chosenFiles)
	// 						})
	// 					}}
	// 				/>
	// 			</Box>
	// 		</Box>
	// 	)
	// }
	return (
		<Dropzone
			onChangeStatus={onFileChange}
			// InputComponent={selectFileInput}
			getUploadParams={fileParams}
			getFilesFromEvent={getFilesFromEvent}
			accept="image/*"
			maxFiles={1}
			maxSizeBytes={3145728}
			inputContent={
				<Box key="Select Files" sx={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%' }}>
					<Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
						{initPreviewUrl ? (
							<img style={{ height: 100 }} src={`${initPreviewUrl}`}></img>
						) : (
							<Typography>
								<Box component={'span'} sx={{ textDecoration: 'underline' }}>
									Click to upload
								</Box>
								<Box component={'span'} sx={{ color: 'black', mx: 1 }}>
									or drag and drop
								</Box>
								<Box color="gray">SVG, PNG, JPG or GIF (max. 3MB)</Box>
							</Typography>
						)}
					</Box>
				</Box>
			}
			styles={{
				previewImage: { width: 'auto', height: 100, maxHeight: 100 },
				dropzone: { overflow: 'hidden' },
				dropzoneActive: { borderColor: 'green' },
			}}
		/>
	)
}
export default ImageUploadComponent;